import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss']
})
export class ScrollTopComponent {
  atTop = true;
  visible = false;

  constructor(router: Router) {
    // Router resets the actual scroll position to top on every navigation
    // (scrollPositionRestoration: 'top'), but this component is mounted once
    // in the app shell and never destroyed, so its own flags must be reset
    // in sync or the button stays visible from the previous page.
    router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.atTop = true;
      this.visible = false;
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.atTop = window.scrollY < 300;
    if (window.scrollY > 0) {
      this.visible = true;
    }
  }

  scroll(): void {
    if (this.atTop) {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
